const routes = {
    LOGIN: {
        HOME: "/login",
        PARTNER: "/login/partner",
        CORPORATION: "/login/corporation",
        COMPANY: "/login/company",
        EMPLOYEE: "/login/employee",
    },
    DASHBOARD: {
        HOME: "/dashboard",
        MANAGE_COMPANY: "/manage-company",
        PAYROLL_TIME_KEEPING: {
            HOME: "/payroll-time-keeping",
            ADD_TIME_CARD: "/add-time-card"
        },
        START_NEW_PAYROLL: "/start-new-payroll"
    },
    EMPLOYEES: {
        HOME: "/employees",
        VIEW: "/view",
        ADD_EDIT_EMPLOYEE: "/add-edit-employee"
    },
    CONTRACTOR: {
        HOME: "/contractor",
        VIEW: "/view",
        ADD_EDIT_CONTRACTOR: "/add-edit-contractor",
    },
    BENEFITS: {
        HOME: "/benefits",
        ADD_EDIT_COMPANY_BENEFIT: "/add-edit-company-benefit",
        ADD_EDIT_EMPLOYEE_BENEFIT: "/add-edit-employee-benefit",
    },
    DEDUCTIONS: {
        HOME: "/deductions",
        ADD_EDIT_MCN_DEDUCTION: "/add-edit-mcn-deduction-benefit",
        ADD_EDIT_CHILD_SUPPORT_DEDUCTION: "/add-edit-child-support-deduction",
    },
    TIME_OFF: {
        HOME: "/time-off",
    },
    REPORTS: {
        HOME: "/reports",
        ALL_REPORTS: "/all-reports",
        AUTHORIZATION_DOCS: "/authorization-docs",
        COMPANY_TAX_DOCS: "/company-tax-docs",
        EMPLOYEE_TAX_DOCS: "/employee-tax-docs",
        CONTRACTOR_TAX_DOCS: "/contractor-tax-docs",
        AUDIT_TRAIL: "/audit-trail",
    },
    EMPLOYEE_PORTAL: {
        HOME: "/employee",
        PROFILE: "/profile",
        CLOCK_TIME: "/clock-time",
        TIME_OFF: "/time-off",
        PAYSTUBS: "/paystubs",
        DOCUMENTS: "/documents",
        ACCOUNT: "/account",
        BANK_ACCOUNT: "/bank-account",
        BENEFITS: "/benefits",
    },
    NOTIFICATIONS: {
        HOME: "/notifications",
    },
    ONBOARDING: {
        HOME: "/onboarding",
        PENDING: "/pending",
    },
    CONTRACTOR_PORTAL: {
        HOME: "/contractor-portal",
        PROFILE: "/profile",
        CLOCK_TIME: "/clock-time",
        PAYMENTS: "/payments",
        DOCUMENTS: "/documents",
        ACCOUNT: "/account",
        BANK_ACCOUNT: "/bank-account",
    },
    SUPER_ADMIN: {
        HOME: "/superadmin",
        TAX_BRACKETS: "/tax-brackets",
    },
}
export default routes;
